<template>
    <p>Crossprom 1 month subscription</p>
</template>

<script>
export default {
    name: 'Description',
}
</script>